import TendencyTag from './TendencyTag';

export default TendencyTag;
